
import { Options, Vue } from "vue-class-component";
//import * as data from "../data/data.json";
// @ts-ignore
import guests from "../data/guestData.js";

@Options({
  props: {
    guests: Array,
  },
  methods: {
    // if they have no media, route to no media page
    sortGuestPath(guest: {
      links?: {
        spotify: string;
        youtubeVideoKey: string;
        youtubeChannel: string;
      };
      _id: string;
    }) {
      // check that media links are good
      const youtubeLinkCheck = (link: string): boolean => {
        return (
          link.includes("http") &&
          link.includes("youtube.com") &&
          link.length > 15 &&
          !link.includes("/c/")
        );
      };
      const spotifyLinkCheck = (link: string): boolean => {
        return (
          link.includes("open.spotify.com/artist") ||
          link.includes("spotify:artist:")
        );
      };
      if (
        (guest.links?.youtubeChannel &&
          youtubeLinkCheck(guest.links?.youtubeChannel)) ||
        (guest.links?.spotify && spotifyLinkCheck(guest.links?.spotify))
      ) {
        this.$router.push({ name: "guest", params: { id: `${guest._id}` } });
      } else {
        this.$router.push({
          name: "guest_no_media",
          params: { id: `${guest._id}` },
        });
      }
    },
    getFormattedImage(guestId: string) {
      return this.guestData
        .filter((guest: { _id: string }) => guest._id === guestId)
        .map((guest: { image: any }) => guest.image);
    },
    /*
    imageValue: function (value: string) {
      const direction =
        value === "x"
          ? this.transformedImage[0]?.banner.x
          : this.transformedImage[0]?.banner.y;
      return typeof direction != undefined ? direction * 100 + "%" : "100%";
    },
  },
  computed: {
    styles() {
      return {
        "object-position": `${this.imageValue("x")} ${this.imageValue("y")}`,
      };
    },
  */
  },
})
export default class GuestLinkCards extends Vue {
  guests!: [];
  guestData = guests;
  /*
  img =
    // @ts-ignore
    typeof this.image === "string" && this.image.slice(this.image.length - 24);
  transformedImage = data.data.transformedImages.filter((images: any) =>
    images.id.includes(this.img)
  );
  */
}
